import React from 'react';

const DisruptTheme = {
  headerLogo: {
    src: '/themes/theme/disrupt/logo.png',
    alt: 'Disrupt - Youth Marketing Agency London',
  },
  darkLogo: {
    src: '/themes/theme/disrupt/logo.png',
    alt: 'Disrupt - Youth Marketing Agency London',
  },
  headerStyle: {
    backgroundColor: '#ffd200',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  isLightOnDark: false,
  loginMessage: (
    <div style={{ border: '1px solid #333', padding: '10px' }}>
      <img height="200" src="/themes/theme/disrupt/logo.png" alt="Disrupt - Youth Marketing Agency London" />
      <h3>Disrupt - Influencer Agency</h3>
      <br />
      <p>We&apos;re an agile youth marketing agency in London specialising in brand strategy, content and influencer marketing and media buying in one place, in real-time</p>
    </div>
  ),
  shareSite: 'https://disruptr.dyzio.co',
};

export default DisruptTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/disrupt.js
 **/